import { render } from "./tren-pendaftaran-member.vue?vue&type=template&id=79701b26&scoped=true"
import script from "./tren-pendaftaran-member.vue?vue&type=script&lang=js"
export * from "./tren-pendaftaran-member.vue?vue&type=script&lang=js"

import "./tren-pendaftaran-member.vue?vue&type=style&index=0&id=79701b26&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79701b26"]])

export default __exports__